var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-5" }, [
    _vm.datos
      ? _c("form", { attrs: { "data-vv-scope": "formCasaMatriz" } }, [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col md:w-1/2 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: {
                    label: "Dirección",
                    maxlength: "100",
                    name: "direccion"
                  },
                  model: {
                    value: _vm.datos.direccion,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "direccion", $$v)
                    },
                    expression: "datos.direccion"
                  }
                }),
                _vm.getError("direccion")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Dirección es obligatoria")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col md:w-1/4 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces",
                      expression: "'required|alpha_spaces'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: { label: "Ciudad", maxlength: "40", name: "ciudad" },
                  model: {
                    value: _vm.datos.ciudad,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "ciudad", $$v)
                    },
                    expression: "datos.ciudad"
                  }
                }),
                _vm.getError("ciudad")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Ciudad es obligatoria")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col md:w-1/4 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces",
                      expression: "'required|alpha_spaces'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: { label: "Comuna", maxlength: "40", name: "comuna" },
                  model: {
                    value: _vm.datos.comuna,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "comuna", $$v)
                    },
                    expression: "datos.comuna"
                  }
                }),
                _vm.getError("comuna")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Comuna es obligatoria")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col md:w-1/4 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: {
                    label: "Teléfono",
                    maxlength: "20",
                    name: "telefono"
                  },
                  model: {
                    value: _vm.datos.telefono,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "telefono", $$v)
                    },
                    expression: "datos.telefono"
                  }
                }),
                _vm.getError("telefono")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Teléfono es obligatorio")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col md:w-1/4 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: {
                    label: "Correo electrónico",
                    maxlength: "50",
                    name: "correoElectronico"
                  },
                  model: {
                    value: _vm.datos.correoElectronico,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "correoElectronico", $$v)
                    },
                    expression: "datos.correoElectronico"
                  }
                }),
                _vm.getError("correoElectronico")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Correo electrónico es obligatorio")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col md:w-2/6 mt-3" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|numeric",
                      expression: "'required|numeric'"
                    }
                  ],
                  staticClass: "w-full",
                  attrs: {
                    label: "Código SII",
                    maxlength: "10",
                    name: "codigoSii",
                    min: "0"
                  },
                  model: {
                    value: _vm.datos.codigoSii,
                    callback: function($$v) {
                      _vm.$set(_vm.datos, "codigoSii", $$v)
                    },
                    expression: "datos.codigoSii"
                  }
                }),
                _vm.getError("codigoSii")
                  ? _c(
                      "span",
                      { staticClass: "text-danger text-sm form-error-message" },
                      [_vm._v("Código SII obligatorio")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row mt-8 mb-8" }, [
            _c(
              "div",
              { staticClass: "vx-col" },
              [
                _c(
                  "vs-button",
                  {
                    attrs: { color: "primary", type: "filled" },
                    on: { click: _vm.validarCasaMatriz }
                  },
                  [_vm._v("Aceptar")]
                )
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }